<template>
  <Modal
    :width="600"
    :visible="previewVisible"
    title="AI翻译"
    cancelText="插入文章"
    okText="替代原文"
    @cancel="previewVisible = false"
  >
    <div class="model-content">
      <div class="article flex-column">
        <!-- <div class="y-center" style="margin-bottom: 20px">
          <div style="width: 100px; text-align: right">选择模型：</div>
          <div class="y-center">
            <div
              class="nav-item xy-center"
              v-for="(item, index) in modelData.modelList"
              :key="index"
              :class="{ active: index === modelData.modelIndex }"
              @click="modelData.modelIndex = index"
              >{{ item.name }}</div
            >
          </div>
        </div> -->
        <div class="flex">
          <div style="width: 100px; text-align: right">原文：</div>
          <div class="flex1">{{ content.slice(0, 2000) }}</div>
        </div>
        <div class="flex" style="margin-top: 30px">
          <div class="x-end" style="width: 100px; text-align: right" @click="onTranslation">
            <img
              v-if="loading"
              class="rotate"
              src="@/assets/images/icon_loading@2x.png"
              style="width: 16px; height: 16px; margin-right: 8px"
            />
            <img
              v-else
              src="@/assets/images/pop_aifanyi@2x.png"
              style="width: 16px; height: 16px; margin-right: 8px"
            />
            <span>AI翻译：</span>
          </div>
          <div class="flex1">{{ text }}</div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="x-end" v-if="!loading" >
        <Button @click="onCancel">插入文章</Button>
        <Button class="button"  type="primary" @click="onSubmit">替代原文</Button>
      </div>
      <!-- <div class="x-end">
        <div class="tips"
          ><span style="color: #f53131">*</span>消耗{{ imagineNum.ai_word }}想象栗，当前剩余{{
            imagineNum.imagine_num
          }}想象栗</div
        >
      </div> -->
    </template>
  </Modal>
</template>

<script>
  import { Modal, Button, message } from 'ant-design-vue';
  import defHttp from '@/jslibs/axios/http';

  export default {
    name: 'AITranslation',
    components: {
      Modal,
      Button,
    },
    props: {
      content: String,
    },
    data() {
      return {
        imagineNum: {},
        previewVisible: false,
        loading: false,
        text: '',
        modelData: {
          modelList: [],
          modelIndex: 0,
          isOpen: false,
        },
      };
    },
    methods: {
      getGptModelList() {
        return defHttp
          .get({
            url: `/v1/cms/GptModelList`,
          })
          .then((res) => {
            this.modelData.modelList = res.result;
          });
      },
      onShow() {
        this.previewVisible = true;
        this.$nextTick(() => {
          this.text = ''
          this.onTranslation();
        });
        // this.getImagineNum();
      },
      onTranslation() {
        if (this.loading) return false;
        this.loading = true;
        // if (this.content.length > 2000) return message.warning(`翻译字数最多2000个字符`);
        defHttp
          .post(`/cms/AiContent/translateContent`, {
              content: this.content.slice(0, 2000),
            })
          .then((res) => {
            this.loading = false;
            this.text = res.data.result;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      onSubmit() {
        this.$emit('onAiTranslation', `${this.text}`, 'substitution');
        this.previewVisible = false;
      },
      onCancel() {
        this.$emit('onAiTranslation', `<br /><br />${this.text}`, 'insertion');
      },
      getImagineNum() {
        defHttp
          .get({
            url: `/v1/cms/GetImagineNum`,
          })
          .then((res) => {
            this.imagineNum = res.result;
          });
      },
    },
  };
</script>

<style lang="less" scoped>
  .model-content {
    padding: 24px;
  }

  .article {
    padding: 20px 30px;
    color: #222;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;

    .nav-item {
      min-width: 90px;
      height: 32px;
      margin-right: 12px;
      padding: 0 10px;
      border-radius: 3px;
      background: #f6f6f6;
      color: #000;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      cursor: pointer;

      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }

      &.active {
        border: 1px solid #000;
        background: #7472f6;
      }
    }
  }

  .tips {
    margin-top: 10px;
    color: #999;
    font-size: 12px;
    font-weight: 400;
  }
</style>
